const { useEffect, useRef } = require('react');
const FormModelUtils = require('./formModelUtils');

module.exports = function useSyncedFormDefaults({
    areEquivalent = FormModelUtils.areEquivalent,
    methods = {},
    processedDefaults = {},
    processedDefaultsSignature = FormModelUtils.stringifyDefaults(processedDefaults),
    syncDefaults = true
}) {

    const prevDefaultsRef = useRef(processedDefaults);
    const prevKeysRef = useRef(Object.keys(processedDefaults));

    useEffect(() => {

        if (!syncDefaults) {
            return;
        }

        const prevDefaults = prevDefaultsRef.current;
        const prevKeys = prevKeysRef.current;
        const currKeys = Object.keys(processedDefaults);

        prevKeys
            .filter((key) => !currKeys.includes(key))
            .forEach((removedFieldKey) => methods.unregister(removedFieldKey));

        currKeys.forEach((fieldKey) => {

            const isAddedField = !prevKeys.includes(fieldKey);
            const defaultChanged = !areEquivalent(
                prevDefaults[fieldKey],
                processedDefaults[fieldKey]
            );

            if (!isAddedField && !defaultChanged) {
                return;
            }

            methods.setValue(fieldKey, processedDefaults[fieldKey], {
                shouldDirty: false,
                shouldTouch: false,
                shouldValidate: false
            });
        });

        prevDefaultsRef.current = processedDefaults;
        prevKeysRef.current = currKeys;
    }, [processedDefaultsSignature, syncDefaults]);
};
